<template>
  <div class="hero-about" v-if="$whitelabel.showHeader">
    <!-- STANDARD  HERO -->
    <div v-if="$whitelabel.short.toLowerCase() !== 'adac'">
      <section class="hero hero-about__wrapper has-background-primary-light has-no-background-print" :style="cssProps" v-bind:class="{'hero__with-badge': this.$whitelabel.heroBadge}">
        <div class="hero-body">
          <div class="container">
            <h1 class="title title--hero mb-5 is-uppercase">
              <span class="hero-titlearea has-background-white" v-html="$whitelabel.heroTitle"></span>
            </h1>
            <h2 class="subtitle" v-if="$whitelabel.hasHeroSubtitle">
              <span class="hero-titlearea has-background-white" v-html="$whitelabel.heroSubtitle"></span>
            </h2>
            <div class="hero-poweredby is-size-7 has-text-weight-bold" v-if="$whitelabel.heroPoweredBy">
              <span v-if="!$whitelabel.poweredByText">powered by</span>
              <span v-if="$whitelabel.poweredByText" v-html="$whitelabel.poweredByText"></span>
              <img class="poweredby-img" :src="'https://assets.urlaubsgutschein.kaufen/whitelabel/we-are.travel.svg'" alt="we-are.travel" fetchpriority="high" width="351" height="70" />
            </div>
            <div class="hero-subcontent is-relative">
              <div>
                <p class="hero-subtext" v-if="$whitelabel.heroInfoText">
                  <span class="hero-subtext-content has-background-white">{{ $whitelabel.heroInfoText }}&nbsp;</span>
                </p>

                <p class="hero-subtext" v-if="$whitelabel.hasHeroAddition">
                  <span class="hero-subtext-content has-background-white has-text-weight-bold is-uppercase" v-html="$whitelabel.heroAdditionText"></span>
                </p>
              </div>

              <HeroBadge />
            </div>
          </div>
        </div>
      </section>

      <Advantages v-bind:size="$whitelabel.homepage.advantages" v-if="$whitelabel.homepage.advantages" class="hero-advantages" />
    </div>

    <!-- ADAC  HERO -->
    <div v-if="$whitelabel.short.toLowerCase() === 'adac'">
      <section class="hero hero-about__wrapper hero--adac has-background-primary-light container has-no-background-print" :style="cssProps">
        <div class="hero-body">
          <div class="container">
            <h1 class="title mb-5 is-size-2">
              <span class="hero-titlearea has-background-secondary has-text-white is-size-4-mobile">Ihr Kurzurlaub</span>
              <span class="is-inline-block-mobile is-size-5-mobile"
                ><span class=" hero-titlearea has-background-white"><span class="is-hidden-mobile ">&nbsp;-</span> clever & günstig</span></span
              >
            </h1>
            <p class="hero-subtext">
              <img importance="high" class="hero-badge" :src="`https://assets.urlaubsgutschein.kaufen/${this.$whitelabel.assetUrl}badge-70percent.svg`" width="180px" alt="bis zu 70% günstiger" fetchpriority="high" />
            </p>
          </div>
        </div>
      </section>
      <div class="notification is-primary container is-size-7-mobile">
        <!-- <strong>Exklusiv für ADAC Mitglieder: </strong>  -->
        <span class="is-hidden-mobile">
          Egal ob ein exklusiver Wellnessurlaub, eine tolle Städtereise oder ein unvergesslicher Wanderurlaub in den Bergen – mit dem ADAC Hotelgutschein finden Sie das richtige Angebot mit bis zu 70% Ersparnis. Die Gutscheine sind bis zu 3 Jahre gültig und auch ideal als Geschenk geeignet.
        </span>
        <span class="is-hidden-tablet">
          Sparen Sie mit dem ADAC Hotelgutschein bis zu 70% auf Ihren Urlaub. Ideal als Geschenk geeignet!
        </span>
        <router-link to="/gutscheinvorteile" class="is-inline-block"><i class="fas fa-angle-double-right"></i> Ihre Gutscheinvorteile </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import HeroBadge from '@/components/HeroBadge'
import Advantages from '@/components/Advantages'

export default {
  name: 'HeroInfo',
  components: {
    HeroBadge,
    Advantages,
  },
  metaInfo() {
    return {
      link: [
        // {
        //   rel: 'preload',
        //   href: `https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.xs.width}&height=${this.$whitelabel.heroImageResolution.xs.height}&gravity=${this.$whitelabel.heroImageResolution.xs.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg`,
        //   crossorigin: 'anonymous',
        //   as: 'image',
        //   imagesizes: '100vw',
        //   imagesrcset: `https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.xl.width}&height=${this.$whitelabel.heroImageResolution.xl.height}&gravity=${this.$whitelabel.heroImageResolution.xl.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg 1418w,
        //   https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.l.width}&height=${this.$whitelabel.heroImageResolution.l.height}&gravity=${this.$whitelabel.heroImageResolution.l.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg 1216w,
        //   https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.m.width}&height=${this.$whitelabel.heroImageResolution.m.height}&gravity=${this.$whitelabel.heroImageResolution.m.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg 960w,
        //   https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.s.width}&height=${this.$whitelabel.heroImageResolution.s.height}&gravity=${this.$whitelabel.heroImageResolution.s.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg 768w,
        //   https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.xs.width}&height=${this.$whitelabel.heroImageResolution.xs.height}&gravity=${this.$whitelabel.heroImageResolution.xs.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg 500w`,
        // },
        {
          rel: 'preload',
          href: `https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.xs.width}&height=${this.$whitelabel.heroImageResolution.xs.height}&gravity=${this.$whitelabel.heroImageResolution.xs.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg`,
          crossorigin: 'anonymous',
          as: 'image',
          media: '(max-width: 768px)',
        },
        {
          rel: 'preload',
          href: `https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.s.width}&height=${this.$whitelabel.heroImageResolution.s.height}&gravity=${this.$whitelabel.heroImageResolution.s.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg`,
          crossorigin: 'anonymous',
          as: 'image',
          media: '(min-width: 769px) and (max-width: 960px)',
        },
        {
          rel: 'preload',
          href: `https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.m.width}&height=${this.$whitelabel.heroImageResolution.m.height}&gravity=${this.$whitelabel.heroImageResolution.m.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg`,
          crossorigin: 'anonymous',
          as: 'image',
          media: '(min-width: 961px) and (max-width: 1216px)',
        },
        {
          rel: 'preload',
          href: `https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.l.width}&height=${this.$whitelabel.heroImageResolution.l.height}&gravity=${this.$whitelabel.heroImageResolution.l.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg`,
          crossorigin: 'anonymous',
          as: 'image',
          media: '(min-width: 1217px) and (max-width: 1418px)',
        },
        {
          rel: 'preload',
          href: `https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.xl.width}&height=${this.$whitelabel.heroImageResolution.xl.height}&gravity=${this.$whitelabel.heroImageResolution.xl.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg`,
          crossorigin: 'anonymous',
          as: 'image',
          media: '(min-width: 1419px)',
        },
      ],
    }
  },
  data() {
    return {
      cssProps: {
        backgroundImage: `url(https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.xs.width}&height=${this.$whitelabel.heroImageResolution.xs.height}&gravity=${this.$whitelabel.heroImageResolution.xs.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg)`,
      },
    }
  },

  methods: {
    onResize() {
      let width = window.innerWidth

      switch (true) {
        case width > 1418:
          this.cssProps.backgroundImage = `url(https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.xl.width}&height=${this.$whitelabel.heroImageResolution.xl.height}&gravity=${this.$whitelabel.heroImageResolution.xl.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg)`
          break
        case width > 1216:
          this.cssProps.backgroundImage = `url(https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.l.width}&height=${this.$whitelabel.heroImageResolution.l.height}&gravity=${this.$whitelabel.heroImageResolution.l.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg)`
          break
        case width > 960:
          this.cssProps.backgroundImage = `url(https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.m.width}&height=${this.$whitelabel.heroImageResolution.m.height}&gravity=${this.$whitelabel.heroImageResolution.m.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg)`
          break
        case width > 768:
          this.cssProps.backgroundImage = `url(https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.s.width}&height=${this.$whitelabel.heroImageResolution.s.height}&gravity=${this.$whitelabel.heroImageResolution.s.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg)`
          break
        case width > 500:
          this.cssProps.backgroundImage = `url(https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.xs.width}&height=${this.$whitelabel.heroImageResolution.xs.height}&gravity=${this.$whitelabel.heroImageResolution.xs.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg)`
          break
      }
    },
  },

  created() {
    this.onResize()
    window.addEventListener('resize', this.onResize)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
}
</script>

<style scoped lang="scss">
$padding: 0.3rem;

.hero-about {
  margin-top: -4.5rem;
  margin-bottom: 2rem;
  position: relative;
}

//target ie11
_:-ms-fullscreen,
:root .hero-about {
  margin-top: -2.5rem;
}

.hero {
  background-size: cover;
  background-position: center center;
}

.hero-body {
  padding-bottom: 4rem;
  padding-top: 4rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;

  @media screen and (min-width: 769px) {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  @media screen and (min-width: 1216px) {
    padding-bottom: 10rem;
  }

  @media screen and (min-width: 1408px) {
    padding-bottom: 13rem;
  }
}

.hero-about__wrapper {
  position: relative;
}

.hero-subtext {
  max-width: 70ch;
  margin-bottom: 1rem;
}

.hero-subtext-content {
  //max-width: 80ch;
  padding: $padding 0;
  line-height: 2.1;
  box-shadow: $padding 0 0 #fff, -$padding 0 0 #fff;
  box-decoration-break: clone;
  position: relative;
  left: $padding;
}

.hero-titlearea {
  padding: $padding 0.5rem;
  box-decoration-break: clone;
  line-height: 1.8;
}

.hero-advantages {
  margin-top: -2rem;
}

.hero__with-badge {
  .hero-subcontent {
    @media screen and (min-width: 580px) {
      display: flex;
    }
  }
}

.hero-poweredby {
  background: #fff;
  //display: inline-block;
  //flex: 0 1 auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  //display: flex;
  align-items: center;
  padding: 0.5rem;
  position: relative;
  //position: absolute;
  //bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  min-width: 210px;
  display: inline-flex;
  align-items: center;
  margin-bottom: 1rem;

  @media screen and (min-width: 769px) {
    //right: 2rem;
    bottom: 2rem;
    position: static;
    transform: none;
    margin-top: -1rem;
  }
}

.poweredby-img {
  height: 24px;
  width: auto;
}

@media screen and (max-width: 480px) {
  .title {
    font-size: 1.5rem;
  }

  .subtitle {
    font-size: 1rem;
  }

  .hero-subtext {
    font-size: 0.85rem;
  }

  .hero-subtext-content {
    line-height: 2;
  }
}

//ADAC OVERWRITES
.hero--adac {
  .hero-badge {
    position: static;
  }
  .hero-body {
    padding-bottom: 0;
    @media screen and (min-width: 768px) {
      padding-bottom: 4rem;
    }
  }

  .hero-subtext {
    //width: 100%;
    margin-left: 3rem;
  }

  .hero-badge {
    @media screen and (max-width: 360px) {
      position: absolute;
      top: 0.5rem;
      right: 0;
    }

    @media screen and (max-width: 480px) {
      max-width: 25vw;
    }
  }

  @media screen and (min-width: 769px) {
    .hero-badge {
      width: 16rem;
    }
  }
}
</style>
